import * as React from 'react';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from 'react-router-dom';

import { SubItem, SubItemTitle, MainContainer, SelectItem, Lines, EmptyText } from './styles';

const ItemsDropdown: React.FC<{
  name: string | undefined;
  Icon: JSX.Element;
  ActiveIcon: JSX.Element;
  subItems: {
    name: string;
    to: string;
    isSelected: boolean;
  }[];
  emptyText?: string;
}> = ({ name, subItems, Icon, ActiveIcon, emptyText }) => {
  const [expanded, setExpanded] = React.useState(true);
  return (
    <>
      <MainContainer
        role="button"
        onClick={() => setExpanded((prev) => !prev)}
        tabIndex={0}
        $selected={subItems.some((i) => i.isSelected)}
      >
        <SubItem>
          {subItems.some((i) => i.isSelected) ? ActiveIcon : Icon}
          <SubItemTitle $isSelected={subItems.some((i) => i.isSelected)}>{name}</SubItemTitle>
        </SubItem>
        {expanded ? (
          <ExpandLessIcon sx={{ color: 'white', opacity: '0.56' }} />
        ) : (
          <ExpandMoreIcon sx={{ color: 'white', opacity: '0.56' }} />
        )}
      </MainContainer>

      {expanded && subItems.length === 0 && emptyText && <EmptyText>{emptyText}</EmptyText>}
      {expanded &&
        subItems.map((item, index) => (
          <SelectItem $isSelected={item.isSelected} key={item.name}>
            <Lines $lastItem={index + 1 === subItems.length} />
            <Link
              to={item.to}
              style={{
                textDecoration: 'none',
                flex: 1,
              }}
            >
              <p>{item.name}</p>
            </Link>
          </SelectItem>
        ))}
    </>
  );
};

export default ItemsDropdown;
